const HTTP_NOT_FOUND = 404;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function readOptionalNumber(value: unknown): number | undefined {
  return typeof value === 'number' ? value : undefined;
}

export function getHttpErrorStatus(error: unknown): number | undefined {
  if (!isRecord(error)) {
    return undefined;
  }

  const response = error['response'];
  const responseStatus = isRecord(response)
    ? readOptionalNumber(response['status'])
    : undefined;
  const status = readOptionalNumber(error['status']);
  const statusCode = readOptionalNumber(error['statusCode']);

  return responseStatus ?? status ?? statusCode;
}

export function isHttpNotFoundError(error: unknown): boolean {
  return getHttpErrorStatus(error) === HTTP_NOT_FOUND;
}
